<template>
  <div class="space-y-3 text-sm">
    <div class="grid grid-cols-2 gap-2">
      <button class="btn btn-sm" @click="refreshInfo">Check Session</button>
      <button class="btn btn-sm" @click="attemptRefresh">Refresh Token</button>
      <button class="btn btn-sm btn-error" @click="signOut">Sign Out</button>
      <button class="btn btn-sm btn-outline" @click="clearStorage">Clear Storage</button>
    </div>
    <div class="space-y-1">
      <div>
        Status:
        <span :class="sessionExists ? 'text-success' : 'text-error'">{{
          sessionExists ? 'ACTIVE' : 'NONE'
        }}</span>
      </div>
      <div>
        User ID: <span class="opacity-80">{{ userId || '—' }}</span>
      </div>
      <div>Access Payload:</div>
      <pre class="bg-base-200 p-2 rounded text-xs overflow-auto max-h-40">{{ payloadPretty }}</pre>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue'
  import Session from 'supertokens-web-js/recipe/session'
  import { useAuthStore } from '@/stores/auth'

  const sessionExists = ref<boolean>(false)
  const userId = ref<string>('')
  const payload = ref<any>(null)
  const auth = useAuthStore()

  const payloadPretty = computed(() => {
    try {
      return JSON.stringify(payload.value ?? {}, null, 2)
    } catch {
      return String(payload.value)
    }
  })

  async function refreshInfo() {
    try {
      sessionExists.value = await Session.doesSessionExist()
      userId.value = sessionExists.value ? await Session.getUserId() : ''
      payload.value = sessionExists.value ? await Session.getAccessTokenPayloadSecurely() : {}
    } catch (e) {
      console.warn('Session info error', e)
    }
  }

  async function attemptRefresh() {
    try {
      await Session.attemptRefreshingSession()
      await refreshInfo()
    } catch (e) {
      console.warn('Refresh error', e)
    }
  }

  async function signOut() {
    try {
      await auth.signOut()
      await refreshInfo()
    } catch (e) {
      console.warn('Signout error', e)
    }
  }

  function clearStorage() {
    try {
      localStorage.clear()
      sessionStorage.clear()
    } catch {}
  }

  // initial load
  refreshInfo()
</script>
